/**
 * Turns a dot delimited string into a dash string
 * @param dotString
 */
export var dotToDash = function dotToDash(dotString) {
  return dotString.replace(/[.]/g, '-');
};